import { observer } from 'mobx-react'
import { FC, useState } from 'react'
import ReplySvg from '@/public/images/common/reply_icon.svg'
import { TransferTokenButton } from '@/components/organisms/TransferTokenButton'
import { IUserBase, TokenTransactionCategoryBase } from '@/types'
import { useStores } from '@/utils'
import { useWallet } from '@solana/wallet-adapter-react'
import styles from './index.module.scss'
import { TokenThanksItem } from '../TokenThanksItem'

type Props = {
  toggleModal: () => void
  respondent: IUserBase
  answerId: string
  amountOfThanks?: number
}

export const ReplyButtonGroup: FC<Props> = observer(({ toggleModal, respondent, answerId, amountOfThanks = 0 }) => {
  const { viewer } = useStores()
  const { connected } = useWallet()
  const [thanks, setThanks] = useState(amountOfThanks)

  const addTransaction = async (amount: string, signature: string): Promise<boolean> => {
    const output = await viewer.viewer?.addTokenTransaction({
      tokenTransaction: {
        amount,
        category: TokenTransactionCategoryBase.FORUM,
        recieverId: respondent?.id,
        signature,
      },
      answerId,
    })

    if (output.isSuccessful) {
      setThanks(thanks + Number(output.data.tokenTransaction.amount))
      return true
    }
    return false
  }

  return (
    <div className={styles.container}>
      <div className={styles.leftContent}>
        {viewer.isSignedIn && (
          <div className={styles.replyGroup} role='button' tabIndex={0} onClick={toggleModal} onKeyPress={toggleModal}>
            <div className={styles.logo}>
              <ReplySvg />
            </div>
            <p className={styles.replyText}>Reply</p>
          </div>
        )}
        {respondent?.profile?.solanaAddress &&
          viewer.isSignedIn &&
          connected &&
          respondent.username !== viewer.viewer?.username && (
            <div className={styles.icon}>
              <TransferTokenButton user={respondent} addTransaction={addTransaction} />
            </div>
          )}
      </div>
      <TokenThanksItem amountOfThanks={thanks} />
    </div>
  )
})
